(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    (function () {
    const wrappers = document.querySelectorAll('.group-flyin[data-flyin]');
    if (!wrappers.length) return;

    const getNum = (v, fallback) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallback;
    };

    wrappers.forEach((wrap) => {
      const inner = wrap.querySelector('.group-flyin__inner');
      if (!inner) return;

      // erst wenn JS läuft -> "ready" (sonst bleibt es normal sichtbar)
      inner.classList.add('flyin-ready');

      const threshold = getNum(wrap.dataset.flyinThreshold, 0.5);
      const reset = (wrap.dataset.flyinReset === 'true' || wrap.dataset.flyinReset === '1');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= threshold) {
            inner.classList.add('flyin-start');
            return;
          }

          if (reset && entry.intersectionRatio <= 0.02) {
            inner.classList.remove('flyin-start');

            // reset, damit es beim nächsten Mal neu startet
            inner.style.animation = 'none';
            inner.offsetHeight;
            inner.style.animation = '';
          }
        });
      }, { threshold: [0, 0.02, threshold, 1] });

      observer.observe(wrap);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
